// Virksomhedsoplysninger og strukturelle data for Godske Byg & Anlæg

export const companyInfo = {
  name: "Godske Byg & Anlæg",
  owner: "Marcel Godske-Hjembæk",
  cvr: "43323709",
  phone: "29248263",
  phoneFormatted: "+45 29 24 82 63",
  email: "gbapost.marcel@gmail.com",
  address: "Hovedgaden 7, 1. sal",
  zipCity: "4440 Mørkøv",
  fullAddress: "Hovedgaden 7, 1. sal, 4440 Mørkøv",
  openingHours: "Mandag - Fredag: 07:00 - 16:00",
  radius: "30 km radius fra Mørkøv",
};

export const navigation = {
  links: [
    { label: "Forside", path: "/" },
    {
      label: "Ydelser",
      path: "/ydelser",
      dropdown: [
        { label: "Udgravning", path: "/ydelser/udgravning" },
        { label: "Fundamenter", path: "/ydelser/fundamenter" },
        { label: "Jordhåndtering", path: "/ydelser/jordhaandtering" },
        { label: "Sandpuder", path: "/ydelser/sandpuder" },
      ],
    },
    { label: "Projekter", path: "/projekter" },
    { label: "Om os", path: "/om-os" },
    { label: "Kontakt", path: "/kontakt" },
  ],
};

export const whyChooseUs = [
  {
    title: "Erfaring",
    description: "Mange års specialiseret erfaring inden for jord-, anlægs- og gravearbejde sikrer et fejlfrit resultat.",
    icon: "Briefcase",
  },
  {
    title: "Præcision",
    description: "Vi anvender avanceret laser- og GPS-styring for at sikre millimeterpræcision i alle udgravninger og sandpuder.",
    icon: "Target",
  },
  {
    title: "Moderne maskinpark",
    description: "Vores maskiner er topmoderne, miljøvenlige og optimeret til både store og små anlægsopgaver.",
    icon: "Cpu",
  },
  {
    title: "Effektiv projektstyring",
    description: "Vi overholder altid aftalte tidsplaner og budgetter gennem struktureret planlægning og tæt dialog.",
    icon: "Calendar",
  },
  {
    title: "Fokus på kvalitet",
    description: "Vi går aldrig på kompromis med kvaliteten. Vores arbejde danner det solide fundament for dit byggeri.",
    icon: "ShieldCheck",
  },
];

export const processSteps = [
  {
    step: "01",
    title: "Dialog & behovsafdækning",
    description: "Vi starter altid med en grundig samtale om dit projekt, hvor vi afdækker dine specifikke behov og krav til jord- og gravearbejdet.",
  },
  {
    step: "02",
    title: "Planlægning",
    description: "Vi udarbejder en præcis tidsplan og et uforpligtende tilbud. Vi sikrer, at alle tekniske tegninger og koter er på plads inden opstart.",
  },
  {
    step: "03",
    title: "Udførelse",
    description: "Vores erfarne maskinførere udfører arbejdet med moderne maskiner og millimeterpræcision, uanset om det gælder udgravning eller sandpude.",
  },
  {
    step: "04",
    title: "Aflevering",
    description: "Vi gennemgår det færdige arbejde sammen med dig og sikrer, at alt er udført til punkt og prikke, før vi forlader byggepladsen.",
  },
];

export const testimonials = [
  {
    name: "Claus L.",
    role: "Kunde, 3byggetilbud.dk",
    text: "En utrolig positiv oplevelse på alle måder. Kommer til aftalte tider og er god til at rådgive om hvilke løsning er bedst. Også til prisen. Vores fundament med fliser og drivhus står yderst skarpt.",
    rating: 5,
  },
  {
    name: "Lars V.",
    role: "Kunde, 3byggetilbud.dk",
    text: "Meget dygtig og omhyggelig flot arbejd.",
    rating: 5,
  },
  {
    name: "Camilla Hansen",
    role: "Grundejer, Mørkøv",
    text: "Fik udført terrænregulering af vores store byggegrund. Meget professionelt arbejde, og jorden blev flyttet og planeret præcis som aftalt. Kan varmt anbefales!",
    rating: 5,
  },
  {
    name: "Thomas Poulsen",
    role: "Byggeleder, Nordisk Byg",
    text: "Deres arbejde med fundamentudgravning er i særklasse. Altid præcise koter og snorlige render. Det gør det efterfølgende murerarbejde utrolig nemt.",
    rating: 5,
  },
  {
    name: "Lars Christensen",
    role: "Privatkunde, Slagelse",
    text: "Hurtig udrykning og yderst professionel jordhåndtering. De klarede både udgravning og bortskaffelse of overskudsjord hurtigt og til en yderst fair pris.",
    rating: 5,
  },
];
